import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'store/hooks';

const getWidgetUrl = (widgetKey: number) => {
    return `${window.location.origin}${window.location.pathname}#widget-${widgetKey}`;
};

const copyAnchor = (widgetKey: number) => {
    const widgetUrl = getWidgetUrl(widgetKey);
    navigator.clipboard.writeText(widgetUrl);
};

export const useCopyAnchor = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    return useCallback((widgetKey: number) => {
        copyAnchor(widgetKey);
        dispatch.vision.notifyUser({
            message: t('widget.copyAnchorMessage'),
            snackType: 'info',
        });
    }, []);
};
